<ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'popover'">
    <span #popover
        [class]="statusClass">
        {{ data.results }}
    </span>
    </ng-container>
    <span *ngSwitchCase="'plainValue'">{{ data.results ?? '' }}</span>
</ng-container>

<ng-template #connect3MetricsPopover>
    <!-- Connect3/Connect All - Display Metrics -->
    <div class="row p-2" style="max-width: 220px;" *ngIf="data?.connect3Metrics">
        <div class="col-4 px-2" *ngFor="let connect3Metric of data.connect3Metrics">
            <div class="card p-1 mx-n1 my-1 text-center font-size-10"
                [ngClass]="getCardClass(connect3Metric.metricCompleted, selectedGame.GameType)"
                style="height:72px">
                <div [hidden]="connect3Metric.metricCompleted"
                    class="d-flex flex-row-reverse">
                    <div class="icon-12 checkMarkConnect3"></div>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center h-100">
                    <div class="metric-container">
                        <div *ngIf="getMetricValue(connect3Metric.MetricID === 0 ? -1 : connect3Metric.MetricID)?.metric == null">
                            <svg class="icon-12 fill-valyrianSteel">
                                <use href="../../../App_Themes/clearview-default/icons/utility/add.svg#add"></use>
                            </svg>
                        </div>
                        <div class="font-size-10">{{ getMetricAbbrevOrGoal(connect3Metric) }}</div>
                        <div *ngIf="getMetricValue(connect3Metric.MetricID)?.targetObj?.Target != null" class="font-size-10">{{
                            getTargetDisplay(connect3Metric) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>